import { useMemo } from 'react';
import { useUser } from 'src/backoffice-app-code/features/Auth/applications/hooks/useUser';
import { TLink } from '../headerBreadcrumbs/Breadcrumbs';
import HeaderBreadcrumbs from '../headerBreadcrumbs/HeaderBreadcrumbs';
import DefaultPage from './DefaultPage';

interface Props {
  children: React.ReactNode;
  title: string;
  links: TLink[];
  breadcrumbsAction?: React.ReactNode;
}

const DefaultPageWithBreadcrumbs: React.FC<Props> = ({
  children,
  title = '',
  links = [],
  breadcrumbsAction = undefined,
}) => {
  const { getHomeRoute } = useUser();
  const homeRoute = useMemo(() => getHomeRoute(), [getHomeRoute]);
  const linksWithHome: TLink[] = useMemo(
    () => [{ name: 'Home', href: homeRoute }, ...links],
    [links, homeRoute]
  );

  return (
    <DefaultPage title={title}>
      <HeaderBreadcrumbs heading={title} links={linksWithHome} action={breadcrumbsAction} />
      {children}
    </DefaultPage>
  );
};

export default DefaultPageWithBreadcrumbs;
